export { localStorage, canUseLocalStorage } from "./local-storage";
